import { ACCESS_TOKEN } from "../components/login/Login";

const Service ={
    stop: false,
    GET: function (url, token){
        if( url.includes("security")){
            if( this.stop) return;
            if( localStorage.getItem(ACCESS_TOKEN) === null){
                const p = Promise.resolve({
                    success: false,
                    msg:'Deslogado!'
                });
                return p;
            }
        }
        const tk = token?token:localStorage.accessToken;
        return fetch(url, {
            headers: {
               'Content-Type': 'application/json',
               Accept: 'application/json',
               Authorization: `Bearer ${tk}`
            }
          }).then( r => {
            const contentType = r.headers.get("content-type");            
            if (r.ok) {
                try{                   
                    if( contentType === 'application/json') return r.json();
                    return r.text();
                }catch(e){
                    console.error("Erro inesperado ", e );
                    // throw "Erro inesperado: "+e; 
                    const p = Promise.resolve({
                        success: false,
                        msg:'Erro inesperado!'
                    });
                    return p;   
                }
            }else{
                if( r.status === 500){
                    // throw "Servidor não responde apropriadamente.";
                    const p = Promise.resolve({
                        success: false,
                        msg:'Erro 500! Servidor não responde apropriadamente.'
                    });
                    return p;
                }
                if( r.status === 404){
                    // throw "API não encontrada no servidor: "+url;
                    const p = Promise.resolve({
                        success: false,
                        msg:"API não encontrada no servidor: "+url
                    });
                    return p;
                }
                if( r.status === 401){
                    // if( localStorage.accessToken ){
                        r.json().then(erro =>{
                            console.error("Erro da requisicao: ",erro);
                            localStorage.setItem("page", window.location.pathname);
                            // setTimeout(function () { window.location.replace("/login"); }, 1000);
                            this.REFRESH();
                            const p = Promise.resolve({
                                success: false,
                                msg:"Acesso não autorizado: 401"
                            });
                            return p;
                        });
                    // }
                    throw "Acesso não permitido: "+url;
                }
                if( r.status === 403){
                    //window.location.replace("/");
                    const p = Promise.resolve({
                        success: false,
                        msg:"Acesso não autorizado:403"
                    });
                    return p;
                }
                return r.json().then(erro =>{
                    console.error("Erro da requisicao: ",erro);
                    if( erro.status === 500){
                        if( erro.message.includes("signature does not match") ||
                            erro.message.includes("JWT expired") 
                          ){
                            // throw "Problema ao verificar credenciais do usuário. Efetue novo login.";
                            const p = Promise.resolve({
                                success: false,
                                msg: "Problema ao verificar credenciais do usuário. Efetue novo login."
                            });
                            return p;
                        }else{
                            // throw (erro && erro.message)?erro.message:"";
                            const p = Promise.resolve({
                                success: false,
                                msg: (erro && erro.message)?erro.message:"Erro não esperado!"
                            });
                            return p;
                        }
                    }else{
                        const p = Promise.resolve({
                            success: false,
                            msg: (erro && erro.message)?erro.message:"Erro não esperado: "+erro.status
                        });
                        return p;
                    }
                });
            }
        });
    },
    POST:function (url, dado){
        if( this.stop) return;
        return fetch(url, {
            method: "POST",
            body: JSON.stringify(dado),
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${localStorage.accessToken}` 
            }
          }).then( r => {
            if (r.ok) {
                return r.json();
            }else{
                
                if( r.status === 500){
                    throw "Servidor não responde apropriadamente.";
                }
                if( r.status === 401){
                    console.error("Erro da requisicao: ",r);
                    this.REFRESH();
                    return;
                    // throw r; //"Usuário não atenticado";
                    
                }
                if( r.status === 403){
                    //window.location.replace("/");
                    throw "Acesso não permitido: "+url;
                    // this.REFRESH();
                    // return;
                }
                return r.json().then(erro =>{
                    console.error("Erro da requisicao: ",erro);
                    if( erro.status === 500){
                        if( erro.message.includes("signature does not match") ||
                            erro.message.includes("JWT expired") 
                          ){
                            throw "Problema ao verificar credenciais do usuário. Efetue novo login.";
                        }else{
                            throw (erro && erro.message)?erro.message:"";
                        }
                    }else{
                        throw erro;
                    }
                });
            }
        });
    },
    LOGIN:function (url, dado){
        return fetch(url, {
            method: "POST",
            body: JSON.stringify(dado),
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                //Authorization: `Bearer ${localStorage.accessToken}` 
            }
          }).then( r => {
            if (r.ok) {
                
                return r.json();
            }else{
                if( r.status === 500){
                    throw "Servidor não responde apropriadamente.";
                }
                return r.json().then(erro =>{
                    console.error("Erro da requisicao: ",erro);
                    if( erro.status === 500){
                        if( erro.message.includes("signature does not match") ||
                            erro.message.includes("JWT expired") 
                          ){
                            throw "Problema ao verificar credenciais do usuário. Efetue novo login.";
                        }else{
                            throw (erro && erro.message)?erro.message:"";
                        }
                    }else{
                        throw erro;
                    }
                });
            }
        });
    },
    UPLOAD: function (url, dado){
        return fetch(url, {
            method: "POST",
            body: dado,
            headers: {
                Authorization: `Bearer ${localStorage.accessToken}` 
            },
            credentials: 'include'
          }).then( r => {
            if (r.ok) {
                return r.text();
            }else{
                throw r.json();
            }
        });
    },
    DOWNLOAD: function(url, nomeArquivo){
        return fetch(url)
        .then(resp => resp.blob())
        .then(blob => {
            console.log( blob );
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          // the filename you want
          a.download = nomeArquivo?nomeArquivo:"modelo.zip";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          alert("Download concluido");
        })
        .catch(() => alert("oh no!"));
    },
    DOWNLOAD_POST: function(url, nomeArquivo, dado ){
        return fetch(url, {
            method: "POST",
            body: JSON.stringify(dado),
            headers: {
                Authorization: `Bearer ${localStorage.accessToken}`,
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            credentials: 'include'
        })
        .then(resp => resp.blob())
        .then(blob => {
            console.log( blob );
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          // the filename you want
          a.download = nomeArquivo?nomeArquivo:"modelo.zip";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          alert("Download concluido");
        })
        .catch(() => alert("oh no!"));
    },
    FETCH: function(url) {
        return fetch(url,
            {
                headers: {            
                    Authorization: `Bearer ${localStorage.accessToken}` 
                }
            }
        )
        .then( r => {
            if (r.ok) {
                return r.text();
            }else{                
                console.log("erro", r)
                throw r;
            }
        });
    },
    DELETE: function(url) {
        return fetch(url, {
          method: "DELETE",
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${localStorage.accessToken}`
          }
        }).then(r => {
          const contentType = r.headers.get("content-type");
          
          if (r.ok) {
            try {
              if (contentType === 'application/json') return r.json();
              return r.text();
            } catch(e) {
              console.error("Erro inesperado ", e);
              throw "Erro inesperado: " + e;
            }
          } else {
            if (r.status === 500) {
              throw "Servidor não responde apropriadamente.";
            }
            if (r.status === 404) {
              throw "API não encontrada no servidor: " + url;
            }
            if (r.status === 401) {
              r.json().then(erro => {
                console.error("Erro da requisição: ", erro);
                localStorage.setItem("page", window.location.pathname);
                setTimeout(function() { window.location.replace("/login"); }, 1000);
                return;
              });
              throw "Acesso não permitido: " + url;
            }
            if (r.status === 403) {
              throw "Acesso não permitido: " + url;
            }
            
            return r.json().then(erro => {
              console.error("Erro da requisição: ", erro);
              if (erro.status === 500) {
                if (erro.message.includes("signature does not match") ||
                    erro.message.includes("JWT expired")) {
                  throw "Problema ao verificar credenciais do usuário. Efetue novo login.";
                } else {
                  throw (erro && erro.message) ? erro.message : "";
                }
              } else {
                throw erro;
              }
            });
          }
        });
    },
    SSE: function(url, eventName, callBack, onOpenClose){
        if (typeof (EventSource) !== "undefined") {
            const tk = localStorage.accessToken;
            if( !tk ){
                if( callBack) callBack({
                    success: false,
                    msg: "Sem autenticação não pode continuar essa operação"
                });
                return;
            }
            const eventSource = new EventSource(url, {
                withCredentials: true
            });
            eventSource.addEventListener(eventName, (event)=> {                
                if( event.data.startsWith("{") || event.data.startsWith("[")){
                    if( callBack)callBack( event.data);
                }//else console.log(3, event.data);
            });
            eventSource.onerror = function (err) {
                console.log('>>>SSE onerro<<');
                if (eventSource.readyState === EventSource.CLOSED) {                    
                    console.error("Conexão fechada de forma permanente.");
                    if( callBack){
                        callBack({
                            success: false,                            
                            msg: 'Conexão fechada de forma permanente.'
                        })
                    }
                } else if (eventSource.readyState === EventSource.CONNECTING) {
                    console.error("Connection lost. Attempting to reconnect...");
                }
                if( err.data){
                    const data = JSON.parse(err.data);
                    if (data.error) {
                        console.error("Server-side error message:", data.error);                        
                    }
                }
            };
            eventSource.onopen = function (event) {
                // console.log("Connection opened"); //
                if( onOpenClose)onOpenClose(true);
            };         
            window.addEventListener('beforeunload', () => {
                console.log(">>>beforeunload<<<");
                if( onOpenClose)onOpenClose(false);
                eventSource.close();
              });
            return eventSource;   
        }else{
            if( callBack) callBack({
                success: false,
                msg: 'Desculpe! Seu navegador não suporta Server-Sent-Events.'
            });
        }
    },
    REFRESH: function(){
        this.stop = true;
        // const refreshToken = this.getCookie("refreshToken");
        const tk = localStorage.accessToken;
        fetch("/api/refresh", {
            method: "POST",
            body: tk
        }).then( r =>{
            if (r.ok) {
                r.json().then(result =>{
                    localStorage.setItem(ACCESS_TOKEN, result.accessToken);
                    // this.GET(url, result.accessToken)
                    window.location.reload(true)
                })
            }else{
                window.location.href = "/login";
                localStorage.removeItem(ACCESS_TOKEN);
                sessionStorage.removeItem("profile");
            }
        }).catch( err =>{
            console.error(err);
            window.location.href = "/login";
            localStorage.removeItem(ACCESS_TOKEN);
            sessionStorage.removeItem("profile");
        })

    },
}
export default Service;